'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var last = require('it-last');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createRm({rmAll}) {
  async function rm(path, options = {}) {
    const cid = await last__default["default"](rmAll([{
        path,
        ...options
      }], options));
    if (!cid) {
      throw new Error('CID expected');
    }
    return cid;
  }
  return rm;
}

exports.createRm = createRm;
